import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isEqual } from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import { styled } from 'styled-components';
import { Box } from "../../../box/src";
export const PixelIndicator = ({ registerEventHandler, }) => {
    var _a, _b;
    const [imageCrop, setImageCrop] = useState({});
    const handleCrop = useCallback((type, details) => {
        if (type !== 'update' || !(details === null || details === void 0 ? void 0 : details.crop)) {
            return;
        }
        const crop = details.crop;
        setImageCrop((prevCrop) => {
            if (isEqual(prevCrop, crop)) {
                return prevCrop;
            }
            return crop;
        });
    }, []);
    useEffect(() => {
        registerEventHandler(handleCrop);
    }, [handleCrop, registerEventHandler]);
    if (!(imageCrop.width && imageCrop.height)) {
        return null;
    }
    return (_jsxs(Wrapper, { children: [_jsx(Bold, { children: (_b = (_a = window === null || window === void 0 ? void 0 : window.__) === null || _a === void 0 ? void 0 : _a.call(window, 'Frame size')) !== null && _b !== void 0 ? _b : 'Frame size' }), _jsxs(Box, { children: [imageCrop.width, " x ", imageCrop.height, " px"] })] }));
};
const Bold = styled(Box).attrs(() => ({
    fontWeight: 2,
    mr: 2,
})) ``;
const Wrapper = styled(Box).attrs(() => ({
    justifyContent: 'flex-end',
    width: 'fit-content',
})) `
  position: absolute;
  bottom: 28px;
  right: 0;
`;
//# sourceMappingURL=PixelIndicator.js.map